import React from 'react'
import EssLayout from '../../../../layout/components/ESSLayout'
import EssPunch from '../../EssAttendance/components/EssPunch'
import { useTheme } from '@mui/material/styles';
import { Box, Fab, useMediaQuery } from '@mui/material';
import { useEssAppData } from '../../../../context/AppESSDataContext';
import { useFilteredTask } from '../../../admin/erp/tasks/hook/useFilteredTask';
import { AccessAlarm, Add, Alarm, ArrowRight, Assignment, CalendarMonth, Schedule, Today } from '@mui/icons-material';
import TaskCardListView from '../../../admin/erp/tasks/components/TaskCardListView';
import { Link } from 'react-router-dom';

function EssDashboardPage() {

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const {taskList,getTaskList} = useEssAppData();
  const { toDos, reminders, leads, mine,myAssigned,highPriority,medPriority,lowPriority,todaysTask,dueToday,overDue,startToday } = useFilteredTask(taskList);

  return (
    <EssLayout>
        <div className='container-fluid mt-1'>
          {isMobile && <EssPunch />}
          <div className='row mt-2'>
            <div className="col-4 col-lg-2 px-1">
                <div className="card bg-mui-info glow-mui-info p-1 ">
                    <p>Todos</p>
                    <div className='d-flex justify-content-between'>
                      <span><Assignment sx={{fontSize:40}}/></span>
                      <span className='me-2'><h1 style={{fontSize:40}}>{toDos.length}</h1></span>
                    </div>
                </div>
            </div>
            <div className="col-4 col-lg-2 px-1">
                <div className="card btn-mui-warning glow-mui-warning  p-1">
                    <p>Reminders</p>
                    <div className='d-flex justify-content-between'>
                      <span><Alarm sx={{fontSize:40}}/></span>
                      <span className='me-2'><h1 style={{fontSize:40}}>{reminders.length}</h1></span>
                    </div>
                    
                </div>
            </div>
            <div className="col-4 col-lg-2 px-1">
                <div className="card bg-forest glow-forest  p-1">
                    <p>Leads</p>
                    <div className='d-flex justify-content-between'>
                      <span><CalendarMonth sx={{fontSize:40}}/></span>
                      <span className='me-2'><h1 style={{fontSize:40}}>{leads.length}</h1></span>
                    </div>
                </div>
            </div>      
          </div>

          {overDue.length > 0 &&
            <>
            <div className='col-12 bg-danger text-white mt-3 p-2'>
              <AccessAlarm/> Overdue({overDue.length})
            </div>
            <TaskCardListView taskList={overDue} callBack={getTaskList} />
            </>
          }

          {dueToday.length > 0 &&
            <>
            <div className='col-12 bg-warning mt-3 p-2'>
              <Schedule/> Need To Finish By Today ({dueToday.length})
            </div>
            <TaskCardListView taskList={dueToday} callBack={getTaskList} />
            </>
          }

          <div className='col-md-12 mt-2'>
            <Link to="task" className='p-3 rounded text-center bg-purple text-white' type="button" >Vew All Task <ArrowRight/></Link>
          </div>


          <Fab size="medium" color="secondary" aria-label="add" sx={{
                  position: 'fixed',
                  bottom: 16, // Distance from the bottom
                  right: 16,  // Distance from the right
                }}>
            <Add />
          </Fab>
        </div>
    </EssLayout>
  )
}

export default EssDashboardPage